/**
 * KAN-735: расход токенов OpenRouter по дням месяца: простой столбчатый график.
 * KAN-799: день без данных по ключу рисуется пустым столбцом с подсказкой;
 * расчёты в lib/expensesTokens, здесь только рендер.
 */
import { NO_KEY_DATA, tokensChartModel } from '@/lib/expensesTokens';
import type { TokensDay } from '@/types/expenses';

export function TokensByDayChart({ days }: { days: TokensDay[] }): JSX.Element {
  if (!days.length) {
    return (
      <p className="text-sm text-gray-500" data-testid="tokens-chart-empty">
        За месяц расхода токенов нет
      </p>
    );
  }
  const model = tokensChartModel(days);
  return (
    <div data-testid="tokens-chart">
      <div className="flex h-40 items-end gap-1 border-b border-gray-200" role="list">
        {model.bars.map((bar) => (
          <div
            key={bar.date}
            role="listitem"
            aria-label={bar.title}
            title={bar.title}
            data-testid={`tokens-bar-${bar.date}`}
            data-has-data={bar.hasData}
            className="flex h-full min-w-[6px] flex-1 flex-col justify-end"
          >
            <div
              className="w-full rounded-t bg-blue-500"
              style={{ height: `${bar.heightPercent}%` }}
            />
            <span className="sr-only">{bar.day}</span>
          </div>
        ))}
      </div>
      <div className="mt-1 flex justify-between text-xs text-gray-400">
        <span>{model.firstDay}</span>
        <span>{model.lastDay}</span>
      </div>
      {model.missingDays > 0 && (
        <p className="mt-2 text-xs text-gray-400" data-testid="tokens-chart-missing">
          {`${NO_KEY_DATA.charAt(0).toUpperCase()}${NO_KEY_DATA.slice(1)}: ${model.missingDays} дн.`}
        </p>
      )}
    </div>
  );
}
